import { useState } from 'react';
import { Skeleton } from '@vitness/ui';
import { useStore } from '../lib/store';
import { RouteHeader } from '../components/RouteHeader';
import { SettingsPanel, type SettingsSectionId } from '../features/settings/SettingsPanel';

export function SettingsRoute() {
  const loading = useStore(s => s.loading);
  const [section, setSection] = useState<SettingsSectionId>('appearance');

  if (loading) {
    return <><Skeleton style={{ height: 52, marginBottom: 22 }} /><Skeleton style={{ height: 320 }} /></>;
  }

  return (
    <>
      <RouteHeader title="Settings" />
      <SettingsPanel section={section} onSection={setSection} />
    </>
  );
}
